<template>
  <validation-observer tag="div" class="" @submit.native.prevent ref="validation">
    <div id="screen-status" role="tabpanel" aria-labelledby="tab-screen-status" class="tab-pane fade active show">
      <div class="card-body">
        <div class="mb-4">
          <h3>Camera Name</h3>
          <validation-provider name="name" vid="name">
              <c-input type="text" v-model="stateName"/>
              <c-help-block />
            </validation-provider>
        </div>

        <hr>

        <div class="mb-4">
          <h3>FTP Connection Details</h3>
          <p>Set this option to get Performa to periodically check an FTP server for new images for a camera.</p>

          <div class="mb-3">
            <c-checkbox v-model="stateConnectionMode" true-value="client_ftp" false-value="">Use Client FTP</c-checkbox>
          </div>

          <div class="mb-3" v-show="camera.connection_mode == 'client_ftp'">
            <label class="form-label">FTP Directory</label>
            <!-- For wireframe only -->
            <span class="text-info ms-3">
                    [Directory on the ftp server to look for new image files]
                </span>
            <c-input type="text" v-model="stateFtpClientDirectory"/>
            <div class="text-end">
              <c-button class="mt-3" @click="handleTest">Test</c-button>
            </div>
          </div>

          <hr>
          <h3>SFTP Server Details</h3>
          <p>Configure the following details into a camera to send images to Performa.</p>
          <div class="md-3">
            <c-checkbox v-model="stateConnectionMode" true-value="sftp" false-value="">Performa SFTP</c-checkbox>
          </div>
          <div v-show="camera.connection_mode == 'sftp'">
            <div class="mb-3">
              <label class="form-label">SFTP Host</label>
              <c-input type="text" v-bind:value="camera.sftp_host" disabled>
                <button slot="append" class="btn btn-outline btn-sm p-0" @click="handleCopy(camera.sftp_host)"><i
                  class="fal fa-copy fs-4"/></button>
              </c-input>
            </div>

            <div class="mb-3">
              <label class="form-label">SFTP Username</label>
              <c-input type="text" v-bind:value="camera.sftp_username" disabled>
                <button slot="append" class="btn btn-outline btn-sm p-0" @click="handleCopy(camera.sftp_username)"><i
                  class="fal fa-copy fs-4"/></button>
              </c-input>
            </div>

            <div class="mb-3">
              <label class="form-label">SFTP Password</label>
              <c-input type="text" v-bind:value="camera.sftp_password" disabled>
                <button slot="append" class="btn btn-outline btn-sm p-0" @click="handleCopy(camera.sftp_password)"><i
                  class="fal fa-copy fs-4"/></button>
              </c-input>
            </div>
          </div>
        </div>

        <div v-if="$can('write screens')" class="row justify-content-md-between align-items-center mt-3">
          <div class="col-auto">
            <c-button variant="danger" type="button" @click="remove">Delete</c-button>
          </div>
          <div class="col-auto">
            <c-button type="submit" @click="save" validate>Save</c-button>
          </div>
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import { stateMapper, helperComputed, helperMethods } from '@/vuex/modules/screens/cameras'
import { get, call } from 'vuex-pathify'
import { toast } from '@chameleon/chameleon-vue'
import swal from 'sweetalert'

export default {
  mixins: [
    stateMapper
  ],

  data () {
    return {
      name: ''
    }
  },

  computed: {
    ...helperComputed,
    ...get('screens', ['screen'])
  },

  watch: {
    $route: {
      async handler () {
        try {
          await this.getCamera(this.$route.params.cameraId)
        } catch (error) {
          toast('Could not find the camera.', 'info')

          this.$router.replace({ name: 'screens' })
        }
      },
      immediate: true
    }
  },

  methods: {
    ...helperMethods,
    ...call('screens/cameras', ['testClientFtp']),

    async save () {
      await this.updateCamera({
        id: this.camera.id,
        payload: {
          connection_mode: this.camera.connection_mode,
          ftp_client_directory: this.camera.ftp_client_directory,
          name: this.camera.name,
        }
      })
      this.getCameras()
      toast('Successfully updated camera', 'success')
    },

    async remove () {
      if (
        !await swal({
          text: 'Are you sure you want to delete the camera and its setting from the screen?',
          buttons: {
            cancel: { text: 'Cancel', visible: true, className: 'btn btn-light' },
            confirm: { text: 'Yes, Delete', visible: true, className: 'btn btn-danger' }
          },
          dangerMode: true
        })
      ) {
        return
      }
      await this.deleteCamera(this.$route.params.cameraId)

      this.$router.replace({ name: 'screens.single.camera-settings' })
      toast('Successfully deleted camera', 'success')
    },

    async handleCopy (text) {
      try {
        await navigator.clipboard.writeText(text)
        toast('Text copied to clipboard!', 'success')
      } catch (error) {
        toast('Failed to copy text', 'danger')
      }
    },

    async handleTest () {
      const response = await this.testClientFtp({ payload: { path: this.camera.ftp_client_directory } })

      if (response.data.successful) {
        toast('Successfully received image', 'success')
      } else {
        toast('Failed to receive image', 'danger')
      }
    }

  }
}
</script>
